; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/Teams/ContentSearch/TeamRelatedResearch',['jquery', 'eventManager', 'matchHeight'], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('jquery'), require('eventManager'), require('matchHeight')) :
            console && console.error('TeamRelatedResearch does not support non-amd script loading.');
}(this/* window */, function ($, eventManager /*, matchHeight */) {

    function RelatedPanel(args) {

        Object.defineProperty(this, 'scope', { value: args.scope, enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, '$scope', { value: $(args.scope), enumerable: !1, configurable: !0, writable: !1 });
        Object.defineProperty(this, '$placeholder', { value: this.$scope.find('.result-placeholder'), enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'timeoutToSearch', { value: args.TimeoutToSearch, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchApiUrl', { value: args.SearchApiUrl, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'componentId', { value: args.ComponentId, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'tilesMaxCount', { value: args.TilesMaxCount, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchRoot', { value: args.SearchRoot, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchablePageTypes', { value: args.SearchablePageTypes || [], enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'tileName', { value: args.TileName, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'noSearchResultsText', { value: args.NoSearchResultsText, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchServiceUnavailableMessage', { value: args.SearchServiceUnavailableMessage, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'teamId', { value: args.TeamId, enumerable: !0, configurable: !0, writable: !0 });

        this.suspendedComponentInit();
    }

    RelatedPanel.prototype.suspendedComponentInit = function suspendedComponentInit() {
        setTimeout(this.getData.bind(this), this.timeoutToSearch);
    }

    /*
     * Get related objects to the current page
     */
    RelatedPanel.prototype.getData = function () {

        var $errorPlaceholder = this.$placeholder.find(".ipa-loader-container");
        $.ajax({
            url: this.searchApiUrl,
            type: "POST",
            data: {
                teamId: this.teamId,
                limit: this.tilesMaxCount,
                searchRootId: this.searchRoot,
                searchablePageTypes: this.searchablePageTypes,
                tileName: this.tileName,
            }
        }).done((function (data) {
            if (!data.trim()) {
                console.log(this.noSearchResultsText);
                this.$scope.hide();
                $('#container-see-more-' + this.componentId).hide();
            } else {
                this.$placeholder.html(data);

                //related research
                this.$scope.find('.mm-tile h2').ellipsis({
                    lines: 3,
                    ellipClass: 'ellip',
                    responsive: true
                });

                this.$scope.find('.search-results-list .mm-tile').matchHeight();
                this.$scope.find('.search-results-list .mm-tile > a').prop('target', '_blank');
            }
        }).bind(this))
            .done(eventManager.trigger.bind(this, 'team_researches_related:resultsLoaded'))
            .fail((function (reason) {
                console && console.log instanceof Function && console.log("error occured during fetching related objects to the current page.", reason);
                $errorPlaceholder.html(this.searchServiceUnavailableMessage);
            }).bind(this));
    };

    RelatedPanel.init = function initRelatedPanel(args) {
        var entity = new RelatedPanel(args);
        return entity;
    }
    return RelatedPanel;
}));
